<div class="content-area mt-5">
    <div *ngIf="members.length > 0">
        <div class="prospectos-table mh-50">
            <table>
                <thead>
                    <tr>
                        <th>Tipo</th>
                        <th>Nombre</th>
                        <th>Cargo</th>
                        <th>Compañia</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of members; let i=index">
                        <td>{{tipo}}</td>
                        <td>{{item.nombre}} {{item.apellido}}</td>
                        <td>{{item.cargo}}</td>
                        <td>{{item.empresa}}</td>
                        <td class="actions-cell">
                            <div class="dropdown-container" (click)="$event.stopPropagation()">
                                <button class="dots-button" (click)="toggleActionsMenu('menu-' + i)">
                                    <svg class="dots-icon" viewBox="0 0 24 24">
                                        <circle cx="12" cy="5" r="2"/>
                                        <circle cx="12" cy="12" r="2"/>
                                        <circle cx="12" cy="19" r="2"/>
                                    </svg>
                                </button>
                                <div class="dropdown-menu" [class.show]="openedMenuId === 'menu-' + i">
                                    <button class="dropdown-item">Eliminar del segmento</button>
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</div>